import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

export function useUsernameAvailability(username: string, checkEnabled: boolean = true) {
  const [isChecking, setIsChecking] = useState(false);
  const [isAvailable, setIsAvailable] = useState<boolean | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    // Skip check if disabled
    if (!checkEnabled) {
      return;
    }
    
    const checkUsername = async () => {
      // Reset states when username changes
      setIsAvailable(null);
      setError(null);

      // Don't check if username is too short
      if (username.length < 3) {
        return;
      }

      // Validate username format
      if (!/^[a-z0-9][a-z0-9_-]{1,28}[a-z0-9]$/.test(username)) {
        setError('Format invalide. Utilisez uniquement des lettres, chiffres, - et _');
        return;
      }

      setIsChecking(true);

      try {
        const { data, error } = await supabase
          .from('profiles')
          .select('username')
          .ilike('username', username)
          .single();

        if (error && error.code !== 'PGRST116') { // PGRST116 = no rows returned
          throw error;
        }

        setIsAvailable(!data);
      } catch (err) {
        console.error('Error checking username:', err);
        setError('Erreur lors de la vérification du nom d\'utilisateur');
      } finally {
        setIsChecking(false);
      }
    };

    // Debounce the check
    const timeoutId = setTimeout(checkUsername, 500);
    return () => clearTimeout(timeoutId);
  }, [username, checkEnabled]);

  return { isChecking, isAvailable, error };
}